export interface AnalyticsColumn {
  header: string;
  /** Field of both a daily row and the month totals. */
  field: string;
}

export interface AnalyticsSection {
  title: string;
  columns: AnalyticsColumn[];
}

/** Tables of the basic analytics page, in display order (legacy `TableItem*` components). */
export const ANALYTICS_SECTIONS: AnalyticsSection[] = [
  {
    title: 'Пользователи',
    columns: [
      { header: 'Всего заказчиков', field: 'customers_all' },
      { header: 'Новых заказчиков', field: 'customers' },
      { header: 'Всего сервисов', field: 'services_all' },
      { header: 'Новых сервисов', field: 'services' },
    ],
  },
  {
    title: 'Заявки',
    columns: [
      { header: 'Всего заявок', field: 'bids_all' },
      { header: 'Новых заявок', field: 'bids' },
      { header: 'Новых прямых заявок', field: 'bids_directed' },
      { header: 'Новых VIN кодов', field: 'vins' },
    ],
  },
  {
    title: 'Платежи',
    columns: [
      { header: 'Cashback', field: 'cashback_sum' },
      { header: 'Пополнено баланса', field: 'balance_refill_sum' },
      { header: 'Онлайн платежей', field: 'bids_payments_count' },
      { header: 'Сумма онлайн платежей', field: 'bids_payments_sum' },
    ],
  },
  {
    title: 'Ответы',
    columns: [
      { header: 'Заявок с 3+ ответами', field: 'bids_three_more_answers' },
      { header: 'Заявок с 1 - 2 ответами', field: 'bids_two_less_answers' },
      { header: 'Заявок без ответов', field: 'bids_no_answers' },
      { header: 'Заявок в архиве за сутки', field: 'bids_archived' },
      { header: 'Среднее количество ответов', field: 'bids_avg_answers' },
    ],
  },
  {
    title: 'Ремонты',
    columns: [
      { header: 'Количество выборов', field: 'bids_chosen' },
      { header: 'Сумма в руб. за выборы', field: 'bids_chosen_pay_sum' },
      { header: 'Выполненных ремонтов', field: 'bids_repaired' },
      { header: 'Сумма в руб. за ремонты', field: 'bids_repaired_pay_sum' },
    ],
  },
  {
    title: 'Отзывы',
    columns: [
      { header: 'Новых отзывов', field: 'reviews' },
      { header: 'Отзывов с 5-4.5 звездами', field: 'reviews_high_score' },
      { header: 'Отзывов с 4.4-3.6 звездами', field: 'reviews_mid_score' },
      { header: 'Отзывов с 3.5-1 звездами', field: 'reviews_low_score' },
      { header: 'Опубликованных отзывов', field: 'reviews_published' },
      { header: 'Неопубликованных отзывов', field: 'reviews_non_published' },
    ],
  },
  {
    title: 'Полисы РГС',
    columns: [
      { header: 'Продано РГС полисов', field: 'rgs_sells' },
      { header: 'Сумма с продаж РГС полисов', field: 'rgs_sells_sum' },
    ],
  },
];
